<template>

  <div>
    <PageHeader title="File Importer" subtitle="Import a PDF or CLEX file to convert into Micro Notes"></PageHeader>

    <div class="main-content container-fluid xs-pt-0">
      <div class="row">
        <div class="col-md-12">
          <Panel class="panel panel-default panel-border-color panel-border-color-primary">
            <PanelBody>
              <div class="row xs-mb-50 xs-mt-20">
                <div class="col-xs-12 col-sm-4 col-xl-2 xs-pt-0 sm-pt-10">
                  <span class="">Type of file to import:</span>
                </div>
                <div class="col-xs-12 col-sm-8 col-xl-4 xs-pt-10 sm-pt-0">
                  <button class="btn btn-xl xs-mr-10" :class="importType=== 'pdf' ? 'btn-outline-primary' : 'btn-outline-default'" v-on:click="importType = 'pdf'"><i class="far" :class="importType=== 'pdf' ? 'fa-check-square' : 'fa-square'"></i> Import a PDF</button>
                  <button class="btn btn-xl" :class="importType=== 'clex' ? 'btn-outline-primary' : 'btn-outline-default'" v-on:click="importType = 'clex'"><i class="far" :class="importType=== 'clex' ? 'fa-check-square' : 'fa-square'"></i> Import CLEX file</button>
                  <span class="text-primary import-other-link" v-on:click="toggleOther" :style="showOther ? 'text-decoration:underline;' : ''">Import other file types</span>
                  <div class="import-other" v-if="showOther">  
                    <p>
                      Upload other file types to Google Drive to convert to PDF.<br />
                      <a href="https://support.google.com/drive/answer/37603?hl=en" target="_blank">Click here to see what types of files can be uploaded to Google Drive.</a>
                    </p>
                    <a href="https://drive.google.com/drive/my-drive" target="_blank" class="btn btn-default">Go to my Google Drive</a>
                    <p class="text-muted xs-mb-0 xs-mt-10">Note: You will need to log in to your Google account.</p>
                  </div>
                </div>
              </div>

              <!-- Select or create subject -->
              <div class="row" v-if="importType=== 'pdf'">
                <div v-if="subjects && subjects.length && !newSubjectTitle" class="col-md-6">
                  <label for="lectureNoteSubject">Place in existing subject</label>
                  <select v-model="selectedSubjectTitle" class="form-control" id="lectureNoteSubject">
                    <option></option>
                    <option v-for="subject in subjects" :value="subject.title">{{ subject.title }}</option>
                  </select>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="newLectureNoteSubject"><span v-if="subjects && subjects.length && !newSubjectTitle">Or </span>Create a new subject</label>
                    <input v-model="newSubjectTitle" type="text" id="newLectureNoteSubject" class="form-control" placeholder="Subject Name">
                  </div>
                </div>
              </div><!-- /.row -->

              <div class="row" v-if="showCourses">
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="courses">Select a Course</label>
                    <select class="form-control" v-model="course_id" id="courses">
                      <option :value="null">-- Select Course --</option>
                      <option v-for="course in allCourses" :value="course.id">{{ course.name }}</option>
                    </select>
                  </div>
                </div>
              </div>

              <div v-if="validSubject && importType=== 'pdf'" class="row">
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="newLectureNoteFirstPage">First PDF Page to Import</label>
                    <input v-model="newLectureNoteFirstPage" type="number" min="0" id="newLectureNoteFirstPage" class="form-control" placeholder="Optional">
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label for="newLectureNoteLastPage">Last PDF Page to Import</label>
                    <input v-model="newLectureNoteLastPage" type="number" min="0" id="newLectureNoteLastPage" class="form-control" placeholder="Optional">
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="alert alert-warning" style="margin-top:27px;padding:10px;" v-if="!validPageNums">Please enter valid values.</div>
                </div>
              </div>
              <div v-else-if="importType=== 'pdf'" class="alert alert-warning"><i class="fas fa-exclamation-triangle"></i> &nbsp; Please select or create a subject to continue</div>

              <div class="row">
                <div class="col-md-12">
                  <!-- url prop never gets hit (because autoProcessQueue=false), but needs to be filled in with something valid -->
                  <div>

                    <h4 v-if="importType=== 'pdf'"><b>Importing to:</b> {{ newSubjectTitle || selectedSubjectTitle }}</h4>
                    <h4 v-else><b>Select an exported .CLEX file</b></h4>

                    <div v-if="roundedUploadProgressPercentage > 0" class="progress">
                      <div class="progress-bar progress-bar-success progress-bar-striped active" role="progressbar" :aria-valuenow="roundedUploadProgressPercentage" aria-valuemin="0" aria-valuemax="100" :style="'width: ' + roundedUploadProgressPercentage + '%'">
                        {{fileName}} -&nbsp;
                        <span v-if="roundedUploadProgressPercentage == 100">Processing...</span>
                        <span v-else> {{roundedUploadProgressPercentage}}%</span>
                      </div>
                    </div>

                    <Dropzone v-else
                              id="pdfUploadDropzone"
                              class="dropzone"
                              url="https://httpbin.org/post"
                              v-on:vdropzone-fileAdded="createLectureNote"
                              :autoProcessQueue="false"
                              :useCustomDropzoneOptions="true"
                              :dropzoneOptions="{
                              'dictDefaultMessage' : ('<div class=&quot;icon&quot;><span class=&quot;mdi mdi-cloud-upload&quot;></span></div><h3>Drag and drop import files here</h3><span class=&quot;note&quot;>(Or click anywhere to select files)</span>') ,
                          'acceptedFiles' : 'application/pdf,.clex' ,
                          'previewTemplate' : '<span></span>' ,
                          }"></Dropzone>
                  </div>
                </div>
              </div>
            </PanelBody>
          </Panel>

        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.main-content -->
  </div><!-- /.div -->


</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
  import Dropzone from '../vue2-dropzone/src/index'
  import Chapter from '../../resources/chapter'

export default {
  components: {
    Dropzone,
  },

  created() {
    this.getSubjects();
    this.getChapters();
    this.getCourses();
  },

  methods: {
    ...mapActions({
      getSubjects: 'getSubjects',
      getChapters: 'getChapters',
      getCourses: 'getCourses',
    }),
    toggleOther() {
      this.showOther = !this.showOther;
    },

    createLectureNote(file) {
      const _this = this;
      this.fileName = file.name;
      
      if (typeof this.newLectureNoteFirstPage == "number" && typeof this.newLectureNoteLastPage == "number" && this.newLectureNoteFirstPage > this.newLectureNoteLastPage) return Toast.error('First PDF page must be lower than last PDF page');

      // check the file type based on the selected import type
      if (file.type != "application/pdf" && this.importType === 'pdf') { return Toast.error('Please select a PDF file.'); }
      if (!this.fileName.toLowerCase().endsWith('.clex') && this.importType === 'clex') { return Toast.error('Please select a .CLEX file.'); }

      if (!this.validSubject && this.importType === 'pdf') return Toast.error('Please select a subject first');
      if (!this.validPageNums) return Toast.error('Please enter valid page numbers');
      if (this.showCourses && this.course_id <= 0) return Toast.error('Please select a course from the dropdown');

      if (this.importType === 'pdf') {
        let formData = new FormData();
        formData.append('lecture_note[pdf]', file);
        formData.append('lecture_note[title]', file.name.replace('.pdf', ''));
        if (this.newLectureNoteFirstPage) formData.append('lecture_note[first_page]', this.newLectureNoteFirstPage);
        if (this.newLectureNoteLastPage) formData.append('lecture_note[last_page]', this.newLectureNoteLastPage);
        const subjectTitle = this.newSubjectTitle || this.selectedSubjectTitle;
        if (subjectTitle) formData.append('lecture_note[subject_title]', subjectTitle);

        formData.append('lecture_note[course_id]', this.course_id);

        // Make request
        this.$http.post('upload', formData, {
          emulateJSON: true,
          timeout: 99999999,
          progress(pe) {
            if (pe.lengthComputable) {
              const progressPercent = (pe.loaded / pe.total) * 100;
              _this.uploadProgressPercentage = progressPercent;
            }
          },
        }).then((res) => {
          if (res.body.id) {
            _this.$router.push({ name: 'processing', params: { id: res.body.id } });
          } else {
            Toast.error('Failed to import lecture note. Please try again.')
          }
        }, (res) => {
          // Reset state
          _this.uploadProgressPercentage = null;
          _this.fileName = null;

          // Show error
          let errMessage = 'Failed to import lecture note';
          if (res.body && _.isArray(res.body.errors)) errMessage = `Error: ${res.body.errors[0]}`;
          Toast.error(errMessage)
        })

      } else if (this.importType === 'clex') {

        let formData = new FormData();
        
        formData.append('archive', file);
        formData.append('filename', file.name.replace('.clex', ''));

        formData.append('course_id', this.course_id);

        const subjectTitle = this.newSubjectTitle || this.selectedSubjectTitle;
        if (subjectTitle) formData.append('subject_title', subjectTitle);

        // Make request
        this.$http.post('micro_notes/import', formData, {
          emulateJSON: true,
          progress(pe) {
            if (pe.lengthComputable) {
              const progressPercent = (pe.loaded / pe.total) * 100;
              _this.uploadProgressPercentage = progressPercent;
            }
          },
        }).then((res) => {
          this.$store.commit('IMPORT_MICRONOTES_SUCCESS', { lecture_note: res.body });
          this.$router.push({
            name: 'micronote-import-success', params: {
              chapters_added: res.body.chapters_added,
              chapters_skipped: res.body.chapters_skipped,
              micronotes_added: res.body.micronotes_added,
              micronotes_skipped: res.body.micronotes_skipped,
              subjects_added: res.body.subjects_added,
              subjects_skipped: res.body.subjects_skipped,
            }
          });

          Toast.success('Micro notes imported')
          }, (res) => {
            // Reset state
            _this.uploadProgressPercentage = null;
            _this.fileName = null;

            // Show error
            let errMessage = 'Failed to import micro notes';
            if (res.body && _.isArray(res.body.errors)) errMessage = 'Error: ${res.body.errors[0]}';
            Toast.error(errMessage);
        })
      }
    },
  },


  computed: {
    ...mapState([
      'currentUser',
    ]),
    ...mapGetters({
      subjects: 'allSubjects',
      chapters: 'allChapters',
      allCourses: 'allCourses',
    }),

    validSubject() {
      if(this.selectedSubjectTitle || this.newSubjectTitle) return true;
    },
    validPageNums() {
      console.log(this.newLectureNoteFirstPage)
      if (this.newLectureNoteFirstPage < this.newLectureNoteLastPage ||
        (!this.newLectureNoteFirstPage && !this.newLectureNoteLastPage)) {
        return true;
      }
      return false;
    },
    roundedUploadProgressPercentage() {
      return Math.round(this.uploadProgressPercentage);
    },
    showCourses() {
      return this.currentUser.role === 'teacher';
    },
  },

  data() {
    return {
      importType: 'pdf',
      fileName: null,
      uploadProgressPercentage: null,
      selectedSubjectTitle: null,
      newSubjectTitle: null,
      newChapterTitle: null,
      newLectureNoteFirstPage: null,
      newLectureNoteLastPage: null,
      showOther: false,
      course_id: null
    }
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  #pdfUploadDropzone { text-align: center; }
  .alert-info {color:#000000;}

  .btn-outline-primary { border: 2px solid #4285f4; color: #4285f4 ;background:#FFFFFF;}
  .btn-outline-default { border: 2px solid #EEEEEE; color: #AAAAAA; background: #FFFFFF; }

  .import-other {border:1px solid #EEEEDD;border-radius:4px;margin-top:15px;padding:15px;}
  .import-other-link { cursor: pointer; display: inline-block; margin: 0px 0px 0px 20px; padding:12px 0px;}
</style>



// WEBPACK FOOTER //
// FileImporter.vue?54ed787c